<template>
  <!-- 
    @Author shirleywanghui@didichuxing.com
    @Date 2022-04-26
    @Description cgc推荐页改版 - 推荐用户教育
    @静态展示组件 无点击行为 无
  -->
    <div class="xtc-share-teach">
      <div class="row1">
        <div class="step">
          <img :src="headImage.TEACH_STEP1_IMAGE" />
          <div class="invite desc">{{step1}}</div>
        </div>
        <div class="arrow">
          <img :src="headImage.TEACH_ARROW_IMAGE" />
        </div>
        <div class="step">
          <img :src="headImage.TEACH_STEP2_IMAGE" />
          <div class="ordered desc">{{step2}}</div>
        </div>
        <div class="arrow">
          <img :src="headImage.TEACH_ARROW_IMAGE" />
        </div>
        <div class="step">
          <img :src="headImage.TEACH_STEP3_IMAGE" />
          <div class="earn desc">{{step3}}</div>
        </div>
      </div>
       
    </div>
</template>
<script>
export default {
  props: {
    country: {
      type: String,
      default: 'MX'
    },
    showLightTheme: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    headImage () {
      if (this.showLightTheme) {
        return {
          TEACH_STEP1_IMAGE: require('../../../../assets/images/cgc/didi/mvp_teach_invited.png'),
          TEACH_STEP2_IMAGE: require('../../../../assets/images/cgc/didi/mvp_teach_friends_register.png'),
          TEACH_STEP3_IMAGE: require('../../../../assets/images/cgc/didi/mvp_teach_earned.png'),
          TEACH_ARROW_IMAGE: require('../../../../assets/images/cgc/didi/mvp_teach_arrow.png')
        }
      }
      if (this.country === 'BR') {
        return {
          TEACH_STEP1_IMAGE: require('../../../../assets/images/cgc/99/teach_invited.png'),
          TEACH_STEP2_IMAGE: require('../../../../assets/images/cgc/99/teach_friends_register.png'),
          TEACH_STEP3_IMAGE: require('../../../../assets/images/cgc/99/teach_earned.png'),
          TEACH_ARROW_IMAGE: require('../../../../assets/images/cgc/99/teach_arrow.png')
        }
      } else {
        return {
          TEACH_STEP1_IMAGE: 'https://img0.didiglobal.com/static/soda_public/do1_6rAuM4bucJYwjb4g8AWD',
          TEACH_STEP2_IMAGE: 'https://img0.didiglobal.com/static/soda_public/do1_GZnpYDCXZjL2Ag5qzamL',
          TEACH_STEP3_IMAGE: 'https://img0.didiglobal.com/static/soda_public/do1_aA1RMLuVJlLHeHKQSIMC',
          TEACH_ARROW_IMAGE: 'https://img0.didiglobal.com/static/soda_public/do1_RH3hE7BiL9viIaI5fh2u'
        }
      }
    },
    step1 () {
      let translate = this._('FoodC_invite_Step_1_IIde' /** 第一步：邀请新用户 */)
      console.log('translate:', translate)
      return translate.split(': ')[1] || translate
    },
    step2 () {
      let translate = this._('FoodC_invite_Step_2_AhBV' /** 第二步：新用户登录并下单成功 */)
      return translate.split(': ')[1] || translate
    },
    step3 () {
      let translate = this._('FoodC_invite_Step_3_VjuY' /** 第三步：获得奖励 */)
      return translate.split(': ')[1] || translate
    }
  }
}
</script>
<style scoped lang="stylus">
.xtc-share-teach {
  margin-top: 60px;
  margin-left: 32px;
  .row1 {
    width: 574px;
    height: 156px;
    display: flex;
    justify-content: space-between;
    .arrow {
      line-height: 90px;
      img {
        width: 32px;
        height: 32px;
      }
    }
    .step {
      position: relative;
      img {
        width: 90px;
        height: 90px;
      }
      .desc {
        font-family: Aspira Light;
        font-size: 22px;
        color: #999999;
        letter-spacing: 0;
        text-align: center;
        line-height: 29px;
        font-weight: 200;
        position: absolute;
        top: 102px;                                                                                                                                       
        left: 50%;
        transform: translateX(-50%)
      }
      .invite {
        flex-wrap: wrap;
        width: 151px;
        height: 54px;
      }
      .ordered {
        // white-space: nowrap;
        width: 295px;
        height: 54px;
      }
      .earn {
        flex-wrap: wrap;
        width: 151px;
        height: 54px;
      }
    }
  }
}
</style>